import abstracts from './abstracts';
import abstractReport from './abstracts-report';
import program from './program';
import common from './common';

var readyCalled = false;
function ready() {
    if (readyCalled)
        return;
    readyCalled = true;

    abstracts();
    abstractReport();
    program();
    common();
}
document.addEventListener('DOMContentLoaded', ready);
